import humps from 'humps'

import { get } from './requests'

export const getPrismicInformation = () => params =>
  get(['prismic'], humps.decamelizeKeys({ params }))
